export const getTransformDecimalValue = (
  wholeLimit: number,
  decimalLimit: number
) => (value: string) => {
  const sign = value.charAt(0) === "-" ? "-" : "";
  const normalizedValue = value
    .replace(/[^0-9.]/g, "")
    .split(".")
    .slice(0, 2)
    .join(".");

  const numberValue = Number(normalizedValue);
  const realWholeLimit = sign ? wholeLimit + 1 : wholeLimit;

  if (!normalizedValue) {
    return `${sign}${normalizedValue || ""}`;
  }

  if (
    Math.floor(numberValue) === numberValue &&
    !normalizedValue.includes(".")
  ) {
    return `${sign}${Number(normalizedValue.slice(0, realWholeLimit))}`;
  }

  const [whole, decimal] = normalizedValue.split(".");

  return `${sign}${Number(whole.slice(0, realWholeLimit))}.${decimal.slice(
    0,
    decimalLimit
  )}`;
};

export const transformPercentageValue = getTransformDecimalValue(3, 2);
export const transformCurrencyValue = getTransformDecimalValue(8, 2);
